<template>
  <div>
    <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen">
        <div v-if="user.is_impersonating" class="w-full flex items-center justify-between px-6 py-4 bg-yellow-500 md:flex-shrink-0 md:justify-center">
          <div class="py-2 text-white text-md font-medium">KUJDES! Ju jeni kyqur me llogarinë e një përdoruesi tjetër. Cdo veprim do të konsiderohet se është kryer nga përdoruesi në fjalë!</div>

          <Link class="btn-indigo ml-12" :href="route('impersonate.leave')">
            <span>Përfundo</span>
          </Link>
        </div>
        <div class="md:flex md:flex-shrink-0">
          <div class="flex items-center justify-between px-6 py-4 bg-indigo-900 md:flex-shrink-0 md:justify-center md:w-60">
            <Link class="mt-1" href="/">
              <logo class="fill-white" width="60" height="28" />
            </Link>
            <dropdown class="md:hidden" placement="bottom-end" :auto-close="true">
              <template #default>
                <svg class="w-6 h-6 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
              </template>
              <template #dropdown>
                <div class="mt-2 px-8 py-4 bg-indigo-800 rounded shadow-lg">
                  <main-menu />
                </div>
              </template>
            </dropdown>
          </div>
          <div class="md:text-md flex items-center justify-between p-4 w-full text-sm bg-white border-b md:px-12 md:py-0">
            <div v-if="user.role === 'superadmin'" class="mr-4 mt-1">Mirësevini në panelin e administratorit kryesor!</div>
            <div v-else-if="user.role === 'admin'" class="mr-4 mt-1">Mirësevini në panelin e administratorit!</div>
            <div v-else-if="user.role === 'seller'" class="mr-4 mt-1">
              Mirësevini në panelin e shitësit!
            </div>
            <div v-else-if="user.role === 'delivery_driver'" class="mr-4 mt-1">Mirësevini në panelin e shoferit shpërndarës!</div>
            <div v-else-if="user.role === 'collecting_driver'" class="mr-4 mt-1">Mirësevini në panelin e shoferit mbledhës!</div>
            <div v-else-if="user.role === 'warehouseman'" class="mr-4 mt-1">Mirësevini në panelin e depoistit!</div>

            <div class="flex mt-1 items-center">

              <dropdown :auto-close="true" placement="bottom-end" v-if="user.role === 'seller'">
                <template #default>
                  <div @click="this.loadAppNotifications();" class="relative  p-2 rounded-lg mr-2">
                    <icon class="w-8 h-8 text-teal-600" :class="{'animate-wiggle' : user.app_unread_notifications_count > 0}" name="notification-bell-1" />
                    <div v-if="user.app_unread_notifications_count > 0" class="px-1.5 py-0.5 bg-indigo-500 min-w-5 rounded-full text-center text-white text-xs absolute -top-1 right-0 translate-x-1/4 text-nowrap">
                      <div class="absolute top-0 right-0 rounded-full -z-10 animate-ping bg-indigo-300 w-full h-full"></div>
                      {{user.app_unread_notifications_count}}
                    </div>
                  </div>
                </template>
                <template #dropdown>
                  <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl max-w-md overflow-y-auto max-h-70vh" ref="notificationsModal" @scroll="scrollListener">

                    <div class="flex justify-between px-2 py-2 border-b-2">
                      <p class="text-base lg:text-xl font-bold">
                        Njoftimet
                      </p>

                      <Link v-if="this.appNotifications.data.length > 0" @click="markAllAsRead" as="button" class="hover:text-indigo-600 focus:text-indigo-600">Lexo të gjitha</Link>
                    </div>

                    <div>
                      <Link @click="markAsRead(notification.id)" :href="route('app-notifications.mark-as-read', {appNotification: notification.id})" v-if="this.appNotifications.data.length > 0" v-for="notification in this.appNotifications.data" class="block px-2 py-2 hover:bg-gray-100 border-b-2" >
                        <div class="flex gap-2">
                          <div class="flex justify-center items-center px-2">
                            <icon class="w-8 h-8" :name="notification.data.icon" />
                          </div>

                          <div class="flex justify-between w-full">
                            <div class="flex flex-col gap-1">
                              <p class="overflow-hidden text-ellipsis max-h-[60px] text-sm lg:text-base font-semibold" style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
                                {{notification.data.title}}
                              </p>

                                <p class="overflow-hidden text-ellipsis max-h-[60px]" style="display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;">
                                {{notification.data.description}}
                                </p>

                              <p>
                                <span class="font-semibold text-indigo-500">
                                {{this.timeAgo(notification.created_at)}}
                                  </span>
                              </p>
                            </div>

                            <div  class="flex justify-end items-center">
                              <icon v-if="notification.read_at == null" name="dot" class="block w-8 h-8 lg:w-12 lg:h-12 fill-indigo-500"></icon>
                              <icon v-else name="dot" class="block w-8 h-8 lg:w-12 lg:h-12 fill-transparent"></icon>
                            </div>
                          </div>

                        </div>
                      </Link>

                      <div v-else class="flex px-2 pr-32 py-2 hover:bg-gray-100">
                        <p class="overflow-hidden text-ellipsis max-h-[60px] text-sm lg:text-base" style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
                          Nuk keni asnje njoftim.
                        </p>

                      </div>
                    </div>

                  </div>
                </template>
              </dropdown>




              <Link v-if="user.role !== 'seller'" href="/scan/dergesat" placement="bottom-end mr-2">
                <icon name="scan-qr" class="mr-2 w-4 h-4 fill-black"
                />
              </Link>

              <dropdown placement="bottom-end" :auto-close="true">
                <template #default>
                  <div class="group flex items-center cursor-pointer select-none">
                    <div class="mr-1 text-gray-700 group-hover:text-indigo-600 focus:text-indigo-600 whitespace-nowrap">
                      <span>{{ auth.user.first_name }}</span>
                      <span class="hidden md:inline">&nbsp;{{ auth.user.last_name }}</span>
                    </div>
                    <icon class="w-5 h-5 fill-gray-700 group-hover:fill-indigo-600 focus:fill-indigo-600" name="cheveron-down" />
                  </div>
                </template>
                <template #dropdown>
                  <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                    <Link class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="`/profili`">Profili im</Link>
                    <Link v-if="user.role === 'seller'" class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="`/konfiguro/njoftimet`">Konfiguro njoftimet</Link>
                    <Link class="block px-6 py-2 hover:text-white hover:bg-indigo-500" href="/fjalekalimi">Ndrysho fjalëkalimin</Link>
                    <Link class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500" href="/logout" method="delete" as="button">Dil</Link>
                  </div>
                </template>
              </dropdown>
            </div>


          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <main-menu class="hidden flex-shrink-0 py-12 pl-8 pr-6 w-60 bg-indigo-800 overflow-y-auto md:block" />
          <div class="px-4 py-8 md:flex-1 md:p-12 md:overflow-y-auto" scroll-region>
            <flash-messages />
            <notifications />
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import Notifications from '@/Shared/Notifications'
import SearchInput from '@/Shared/SearchInput'

import { computed } from 'vue'
import { Head, usePage } from '@inertiajs/inertia-vue3'
import axios from 'axios'


export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    Logo,
    MainMenu,
    Notifications,
    SearchInput,
    Head
  },
  props: {
    auth: Object,
  },
  mounted() {
    this.loadAppNotifications();

    document.addEventListener("click", this.unlockAudio, { once: true });

    if(this.user.role === 'seller'){
      Echo.private('App.Models.User.' + this.user.id)
        .notification((notification) => {
          this.user.app_unread_notifications_count += 1;

          // play sound
          if (!this.audioCtx || !this.audioBuffer) {
            console.log("Audio not ready yet.");
            return;
          }

          const source = this.audioCtx.createBufferSource();
          source.buffer = this.audioBuffer;
          source.connect(this.audioCtx.destination);
          source.start(0);
        });
    }

  },
  data(){
    return {
      appNotifications: {
        data: [],
        currentPage: 1,
        lastPage: 1,
      },
      audioCtx: null,
      audioBuffer: null,
      audioUnlocked: false,
    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  methods: {
    loadAppNotifications(page = 1){
      if(this.user.role === 'seller'){
        axios.get('/app-notifications/list', {params: {page}}).then(response => {
          this.appNotifications.data = page === 1 ? response.data.data : this.appNotifications.data.concat(response.data.data);
          this.appNotifications.currentPage = response.data.current_page
          this.appNotifications.lastPage = response.data.last_page
        });
      }
    },

    loadMoreNotifications(){
      let modal = this.$refs.notificationsModal; // Get the modal element

      if(!modal)
        return;

      let threshold = 640; // Load more when the user is 50px above the bottom
      let isNearBottom = modal.scrollTop + modal.clientHeight >= modal.scrollHeight - threshold;

      let currentPage = this.appNotifications.currentPage
      let lastPage = this.appNotifications.lastPage

      if (isNearBottom && currentPage < lastPage) {
        this.loadAppNotifications(currentPage + 1)
      }
    },

    scrollListener(){
      this.debounce(this.loadMoreNotifications, 200)
    },

    debounce(method, delay){
      clearTimeout(method._tId);
      method._tId = setTimeout(function(){
        method();
      }, delay);
    },

    markAsRead(notificationId){
      this.appNotifications.data.find((item) => item.id === notificationId).read_at = Date.now();
    },

    markAllAsRead(){
      axios.get('/app-notifications/mark-all-as-read').then(response => {
        if(response.data.success){
          this.loadAppNotifications();
          this.appNotifications.data.forEach((item) => item.read_at = Date.now());
        }
      });
    },

    timeAgo(date) {

      const time = new Date(date)
      const now = new Date();
      const seconds = Math.floor((now - time) / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
      const months = Math.floor(days / 30);
      const years = Math.floor(days / 365);

      if (seconds < 60) {
        return `${seconds} ${seconds === 1 ? 'sekond' : 'sekonda'} më parë`;
      } else if (minutes < 60) {
        return `${minutes} ${minutes === 1 ? 'minutë' : 'minuta'} më parë`;
      } else if (hours < 24) {
        return `${hours} orë më parë`;
      } else if (days < 30) {
        return `${days} ditë më parë`;
      } else if (months < 12) {
        return `${months} muaj më parë`;
      } else {
        return `${years} ${years === 1 ? 'vit' : 'vite'} më parë`;
      }
    },

    async unlockAudio() {
      if (this.audioUnlocked) return; // Prevent multiple unlock attempts

      try {
        this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        const response = await fetch("/storage/sounds/notification.mp3");
        const arrayBuffer = await response.arrayBuffer();
        this.audioBuffer = await this.audioCtx.decodeAudioData(arrayBuffer);

        this.audioUnlocked = true;
        console.log("Audio unlocked and loaded!");
      } catch (error) {
        console.error("Failed to unlock audio:", error);
      }
    },
  }
}
</script>
